import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class CsvExportService {
	constructor() {}

	downloadCsvFile(fileName: string, headers: Array<string>, content: Array<Array<string>>) {
		content.unshift(headers);
		let csvContent = 'data:text/csv;charset=utf-8,';
		csvContent += content.map((e) => e.join(',')).join('\n');
		let encodedUri = encodeURI(csvContent);
		let link = document.createElement('a');
		link.setAttribute('href', encodedUri);
		link.setAttribute('download', `${fileName}.csv`);
		document.body.appendChild(link);

		link.click();
	}
}
